module.exports = __webpack_public_path__ + "static/media/tic-ms-instruments-icon.72be53d4.png";